function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionDecoder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M44.36 23.96v10.31c0 1.01-.48 1.77-1.33 2.27-3.17 1.86-6.34 3.72-9.52 5.56-2.76 1.6-5.52 3.19-8.27 4.8-1.1.64-2.08.41-3.11-.21-3.06-1.82-6.14-3.59-9.22-5.38-2.77-1.61-5.55-3.21-8.32-4.83-.72-.42-1.14-1.1-1.14-1.96-.01-7.06-.01-14.11 0-21.17 0-.95.52-1.6 1.31-2.06 1.74-1.02 3.48-2.02 5.23-3.03 2.22-1.29 4.45-2.57 6.67-3.86 1.93-1.12 3.88-2.21 5.79-3.37 1-.61 1.92-.57 2.89-.01 3.34 1.94 6.68 3.88 10.01 5.82 2.61 1.52 5.22 3.04 7.83 4.57.84.49 1.21 1.28 1.21 2.23-.02 3.45-.03 6.89-.03 10.32zm-16.85-2.23c0-1.15-.07-2.23.02-3.3.14-1.8 1.62-3 3.15-2.93 1.86.09 3.08 1.44 3.09 3.31v3.28c0 .65.37 1.03 1.02 1.06.44.02.88.02 1.31.01.82-.02 1.2-.4 1.2-1.22.01-1.09-.02-2.19.01-3.28.08-3.81-3.41-7.1-7.36-6.66-1.95.22-3.44 1.14-4.63 2.63-.96 1.21-1.35 2.61-1.36 4.13-.01.97 0 1.94 0 2.97h-9.69c-1.23 0-2.14.9-2.14 2.12v8.39c0 1.18.92 2.11 2.1 2.12 5.1.01 10.21.01 15.31 0 1.24 0 2.17-.93 2.17-2.18.01-2.76.01-5.52 0-8.29 0-1.25-.92-2.16-2.18-2.16-.65-.01-1.3 0-2.02 0z",
    style: {
      fill: "#d0e0f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.51 21.73h2.03c1.26.01 2.17.91 2.18 2.16.01 2.76.01 5.52 0 8.29 0 1.24-.93 2.18-2.17 2.18-5.1.01-10.21.01-15.31 0-1.19 0-2.1-.93-2.1-2.12v-8.39c0-1.22.91-2.12 2.14-2.12h9.69c0-1.02-.01-2 0-2.97.01-1.52.4-2.92 1.36-4.13 1.19-1.5 2.67-2.42 4.63-2.63 3.94-.44 7.44 2.85 7.36 6.66-.02 1.09 0 2.19-.01 3.28 0 .82-.38 1.2-1.2 1.22-.44.01-.88.01-1.31-.01-.65-.03-1.02-.41-1.02-1.06-.01-1.09 0-2.19 0-3.28 0-1.87-1.22-3.22-3.09-3.31-1.53-.07-3.01 1.12-3.15 2.93-.1 1.06-.03 2.14-.03 3.3z",
    style: {
      fill: "#4678bc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionDecoder);
export default __webpack_public_path__ + "static/media/transaction-decoder.64f110486f0d1b07b1f3205909caff2c.svg";
export { ForwardRef as ReactComponent };